module.exports = __webpack_public_path__ + "static/media/user_guide.3759cdb6.svg";